
import React from 'react';
import { ClubList } from './ClubList';

export const ClubManagement = () => {
  return <ClubList />;
};
